import { QuestionBase } from "../../form/models/question-base.model";
// import { AssessmentQuestionBase } from "./assessment-question-base.model";

export class TextEntryQuestion extends QuestionBase<string> {
    controlType = 'text-entry-question';
    textEntrytype: string;
    placeholder: string;
    disabled: boolean;
    visible: boolean;
    searchable: boolean;
    cstm_error_msg:any;
    conditions: any=[];
    calculation_formula: any;
    calculated_field: boolean;
    select_defination: any;
    pattern: string;
    maxlength: string;
    minlength: string;
    calculated_field_type: string;

  constructor(options: {} = {}) {
    super(options);
    this.textEntrytype = options['textEntrytype'] || '';
    this.placeholder = options['placeholder'] || '';
    this.disabled = options['disabled'] || '';
    this.visible = (options['visible'] == undefined) ? true : options['visible'];
    this.searchable = (options['searchable'] == undefined) ? false : options['searchable'];
    this.cstm_error_msg = options['cstm_error_msg'];
    this.conditions = options['conditions'];
    this.calculation_formula = options['calculation_formula'];
    this.calculated_field = (options['calculated_field'] == undefined) ? true : options['calculated_field'];
    this.select_defination = options['select_defination'] || '';
    this.required = (options['required'] == undefined) ? false : options['required'];
    this.pattern = options['pattern'] || ''; 
    this.maxlength = options['maxlength'] || '';
    this.minlength = options['minlength'] || '';
    this.calculated_field_type = options['calculated_field_type'] || '';
  }
}
